import React from 'react';
import LocaleContext from '../../state/contexts/LocaleContext'
import { messages } from './Welcome.i18n'

import {ArticleArea} from '../../Styling/Layout/ContentArea'

const Welcome = (props) => {

    const locale = React.useContext(LocaleContext);
    const { Header1, Paragraph1 } = messages[locale]

    return (
        <ArticleArea>
            <h1>{Header1}</h1>
            <p>{Paragraph1}</p>
        </ArticleArea>
    )
}

export default Welcome